import { usePathname } from "expo-router";

import { LoadingScreen } from "@/blocks/LoadingScreen";
import { useCurrentPatientQuery } from "@/data/queries/patientsQueries";
import { useApplyPreferredLanguage } from "@/hooks/useApplyPreferredLanguage";
import { useSyncPreferredLanguage } from "@/hooks/useSyncPreferredLanguage";
import { checkIsMfaEnrolmentPathname } from "@/utils/routing";

import { CurrentPatientContext } from "./CurrentPatientContext";

export const CurrentPatientContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { data: patient, isLoading } = useCurrentPatientQuery();
  const isApplyingPreferredLanguage = useApplyPreferredLanguage(patient);
  const pathname = usePathname();

  useSyncPreferredLanguage(patient);

  // The API refuses a username account until its session carries an SMS factor,
  // so enrolment has to render before patient data can load.
  if (checkIsMfaEnrolmentPathname(pathname)) {
    return children;
  }

  if (isLoading || !patient || isApplyingPreferredLanguage) {
    return <LoadingScreen />;
  }

  return (
    <CurrentPatientContext.Provider value={patient}>
      {children}
    </CurrentPatientContext.Provider>
  );
};
